import { get, has, pickBy } from 'lodash'

const types = {
  SET_SELECTED_ROWS_FILTER: 'SET_SELECTED_ROWS_FILTER',
}

export const hamburgerActions = {
  setSelectedRowsFilter({ commit }, { selectedRowsFilter }) {
    commit(types.SET_SELECTED_ROWS_FILTER, { selectedRowsFilter })
  },
}

export const hamburgerGetters = {
  areActionButtonsVisible: (_, getters) => {
    return getters.showActionButtons && !!getters.processActions.length
  },
  areGroupActionsAvailable: (_, getters) => {
    return !getters.isSqlChosen &&
      getters.showGroupActionsButton
  },
  areGroupActionsEnabled: (_, getters) =>
    getters.runGroupActionsOnAllWithoutSelect ||
    getters.selectedRows.length,
  hasButton: (_, getters) => (buttonName) => has(getters.buttons, buttonName),
  hasExportTypesAvailable: (_, getters) =>
    Object.keys(pickBy(get(getters.exportSettings, 'exportTypes', {}))).length,
  isExportAvailable: (_, getters) => getters.showExportButton && getters.hasExportTypesAvailable,
  runGroupActionsOnAllWithoutSelect: (_, getters) =>
    get(getters.hamburgerSettings, 'runGroupActionsOnAllWithoutSelect', false),
  showColumnSelector: (_, getters) =>
    getters.visibilityState({ key: 'showColumnSelector' }) &&
    getters.hasButton('toggle'),
  showExportButton: (_, getters) =>
    get(getters.exportSettings, 'showExportButton', getters.visibilityState({ key: 'showExportButton' })),
  showListOrder: (_, getters) => getters.visibilityState({ key: 'showListOrder' }),
  showPageLimiter: (_, getters) => getters.visibilityState({ key: 'showPageLimiter' }),
  showGroupActionsButton: (_, getters) => getters.visibilityState({ key: 'showGroupActionsButton' }),
  showSavedFilter: (_, getters) => getters.visibilityState({ key: 'showSavedFilter' }),
}

export const hamburgerMutations = {}